import React from 'react';

const Carousel = () => {
  // Sample company logos (in a real app, these would be actual image URLs)
  const companies = [
    { id: 1, logo: '/Images/37military.jpg', alt: '37 military hospital' },
    { id: 2, logo: '/Images/CPMR.jpg', alt: 'Center for Plant medicinal research' },
    { id: 3, logo: '/Images/CSIR.jpg', alt: 'Council for scientific and industrial research' },
    { id: 4, logo: '/Images/entrance.jpg', alt: 'entrance pharmaceuticals' },
    {id: 5, logo: '/Images/gaeast.png', alt: 'Ga East Municipal Hospital'},
    {id: 6, logo: '/Images/noguchi.png', alt: 'Noguchi memorial'},
    {id: 7, logo: '/Images/GSA.png', alt: 'Ghana Standards Authority'},
    {id: 8, logo: '/Images/Nyaho.png', alt: 'Nyaho'},
    {id: 9, logo: '/Images/FDA.png', alt: 'FDA'},
    {id: 10, logo: '/Images/ugmc.svg', alt: 'ugmc'},
    {id: 11, logo: '/Images/cape-coast-hospital.jpg', alt: 'capecoast hospital'},
    {id: 12, logo: '/Images/wacci.jpg', alt: 'wacci'},
    {id: 13, logo: '/Images/Kinapharma.png', alt: 'Kinapharma'},
    {id: 14, logo: '/Images/GIDC.jpg', alt: 'GIDC'},
  ];

  // Double the array for seamless infinite scroll
  const duplicatedCompanies = [...companies, ...companies];
  return (
    <div className="carousel-wrapper">
        <h3>Shaping Careers Through Real-World Opportunities</h3>
        <p className="carousel-description">Over the years, our students have interned at renowned institutions, gaining hands-on skills, industry exposure, and professional networks that prepare them for impactful careers</p>
      <div className="carousel-container">
        <div className="carousel-track">
          {duplicatedCompanies.map((company, index) => (
            <div key={`${company.id}-${index}`} className="company-slide">
              <img 
                src={company.logo} 
                alt={company.alt}
                className="company-logo"
              />
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`        .carousel-wrapper {
          width: 100%;
          margin: 2rem 0;
          overflow: hidden;
          padding: 40px 0;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-top: 1px solid rgba(0,0,0,0.05);
          border-bottom: 1px solid rgba(0,0,0,0.05);
          box-shadow: 0 5px 15px rgba(0,0,0,0.03);
        }

        .carousel-wrapper h3 {
          font-size: 1.8rem;
          font-weight: 600;
          text-align: center;
          margin-bottom: 30px;
          color: #213547;
          position: relative;
          padding-bottom: 12px;
        }
          .carousel-wrapper h3:after {
          content: '';
          position: absolute;
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, #213547, #4682b4);
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
        
        .carousel-description {
          text-align: center;
          color: #666;
          margin: -15px auto 30px;
          max-width: 600px;
          font-size: 1.1rem;
        }.carousel-container {
          width: 100%;
          position: relative;
          overflow: hidden;
          margin: 0 auto;
          max-width: 1400px;
          padding: 0 20px;
        }

        .carousel-track {
          display: flex;
          animation: scroll 40s linear infinite;
          width: fit-content;
          will-change: transform;
        }        .company-slide {
          flex: 0 0 auto;
          width: 200px;
          margin: 0 30px;
          padding: 15px;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          text-align: center;
          background-color: white;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transform: translateY(0);
          position: relative;
        }

        .company-slide:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
        }

        .company-logo {
          width: 100%;
          height: 100px;
           filter: grayscale(0%);
          object-fit: contain;
          opacity: 0.7;
          transition: all 0.4s ease;
        }

        .company-slide:hover .company-logo {
           filter: grayscale(100%);
          opacity: 1;
          transform: scale(1.05);
        }

        .company-name {
          display: none;
        }        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* Pause animation on hover with smooth transition */
        .carousel-track:hover {
          animation-play-state: paused;
        }
        
        /* Add subtle pulsing effect to indicate active company */
        .company-slide:hover::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 30%;
          height: 3px;
          background: linear-gradient(90deg, #4682b4, #5d9cec);
          border-radius: 3px;
        }        /* Responsive adjustments */
        @media (max-width: 768px) {
          .carousel-wrapper h3 {
            font-size: 1.5rem;
          }
          
          .company-slide {
            width: 150px;
            margin: 0 15px;
            padding: 10px;
          }
          
          .carousel-track {
            animation-duration: 25s;
          }
          
          .company-logo {
            height: 80px;
          }
        }

        @media (max-width: 480px) {
          .carousel-wrapper {
            padding: 30px 0;
          }
          
          .carousel-wrapper h3 {
            font-size: 1.3rem;
            margin-bottom: 20px;
          }
          
          .company-slide {
            width: 120px;
            margin: 0 10px;
            padding: 8px;
          }
          
          .carousel-track {
            animation-duration: 20s;
          }
          
          .company-logo {
            height: 70px;
          }
        }
      `}</style>
    </div>
  );
};

export default Carousel;